import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth.js'
import common from './modules/common'
import imagesInline from './modules/images_inline'
import importProductModule from './modules/import-product.js'
import lang from './modules/lang.js'
import priceList from './modules/price_list'
import productIds from './modules/product_ids.js'
import shipping from './modules/shipping'
import myStoresModule from './modules/stores'
import notificationModule from '~/components/UI/app-notification/store'
import onboardingStoreWizard from '~/store/modules/onboarding-store-wizard'

Vue.use(Vuex)

const store2 = new Vuex.Store({
  modules: {
    auth,
    common,
    images_inline: imagesInline,
    importProductModule,
    lang,
    price_list: priceList,
    product_ids: productIds,
    shipping,
    myStoresModule,
    notificationModule,
    onboardingStoreWizard,
  },
})

window.store2 = store2
export default store2